import React, { useState } from "react";
import "./Navbar.css";
import { Link } from "react-router-dom";
// import Hamburger from "hamburger-react";
const Navbar = () => {
  const [hide, setHide] = useState(true);
  const [logo, setLogo] = useState(false);
  const handleClick = () => {
    setHide(!hide);
    setLogo(!logo);
  };
  return (
    <div>
      <div className="yellowbg"> </div>
      <div className={"sidebar" + (hide ? "hide" : "")}>
        <Link className="link" to="/">
          <li className={hide ? "hide" : ""}>HOME</li>
        </Link>
        <Link className="link" to="/about">
          <li className={hide ? "hide" : ""}>ABOUT</li>
        </Link>
        <Link className="link" to="/rooms">
          <li className={hide ? "hide" : ""}>ROOMS</li>
        </Link>
        <Link className="link" to="/wedding">
          <li className={hide ? "hide" : ""}>WEDDING </li>
        </Link>
        <Link className="link" to="/gallery">
          <li className={hide ? "hide" : ""}> GALLERY</li>
        </Link>
        <Link className="link" to="/boook_now">
          <li className={hide ? "hide" : ""}>BOOK NOW</li>
        </Link>
      </div>
      <div className="navbar">
        <img
          className={logo ? "logo" : ""}
          src="/Assets/logo.svg"
          alt="Logo"
        ></img>
        <div className="nav-content">
          <Link className="link" to="/">
            <div className="nav-text">HOME</div>
          </Link>
          <Link className="link" to="/about">
            <div className="nav-text"> ABOUT</div>
          </Link>
          <Link className="link" to="/rooms">
            <div className="nav-text"> ROOMS</div>
          </Link>
          <Link className="link" to="/wedding">
            <div className="nav-text">WEDDING </div>
          </Link>
          <Link className="link" to="/gallery">
            <div className="nav-text"> GALLERY</div>
          </Link>
          <Link className="link" to="/boook_now">
            <div className=" book-now">BOOK NOW</div>
          </Link>
        </div>
        {!hide ? (
          <img
            className="cross"
            src="/Assets/cross.webp"
            onClick={handleClick}
            alt="option"
          ></img>
        ) : (
          <img
            className="hamburger"
            src="/Assets/hamburger.webp"
            alt="option"
            onClick={handleClick}
          ></img>
        )}
      </div>
    </div>
  );
};

export default Navbar;
